import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import "../CSS/withdrawal-log.css";
import { useServerError } from "../Utils/handleServerError";
import UserService from "../Services/UserService";

const UserWithdrawalLog = () => {
  const { users, selectedUser } = useSelector((state) => state.usersSlice);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  const { token } = useSelector((state) => state.authSlice);

  const [error, setError] = useState(null);

  useServerError(error);

  function openErrorMessage(error) {
    setError(error);

    setTimeout(() => {
      setError(null);
    }, 4000);
  }

  const selectedUserData = useMemo(() => {
    return users.filter((user) => user.user_id === selectedUser)[0] || null;
  }, [selectedUser, users]);

  const fetchUserWithdraws = async (user_id) => {
    try {
      setLoading(true);
      const res = await UserService.get_user_withdrawal_log(token, user_id);

      setData(res.data);
    } catch (error) {
      openErrorMessage(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (selectedUser && token) {
      fetchUserWithdraws(selectedUser);
    }
  }, [selectedUser, token]);

  if (!selectedUser) return null;

  return (
    <div className="main_routes bv-user-withdrawal-log">
      <h4>
        Withdrawal Log For {selectedUserData.first_name}{" "}
        {selectedUserData.last_name}
      </h4>

      {loading && <div className="loading">Loading...</div>}

      {!loading && selectedUser && (
        <div className="responsive-table">
          <table>
            <tr>
              <th>Transaction ID</th>
              <th>Date</th>
              <th>Amount</th>
              <th>Method</th>
              <th>Wallet Address</th>
              <th>Account Number</th>
              <th>Account Name</th>
              <th>Bank Name</th>
              <th>Swift Code</th>
              <th>Routing Number</th>
              <th>Status</th>
            </tr>

            {data.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{new Date(item.created_at).toISOString().split("T")[0]}</td>
                <td>{item.amount}</td>
                <td>{item.type}</td>
                <td>{item.wallet_address || "N/A"}</td>

                <td>{item.account_no || "N/A"}</td>

                <td>{item.account_name || "N/A"}</td>

                <td>{item.bank_name || "N/A"}</td>

                <td>{item.swift_code || "N/A"}</td>

                <td>{item.routing_number || "N/A"}</td>

                <td>{item.status}</td>
              </tr>
            ))}
          </table>
        </div>
      )}
    </div>
  );
};

export default UserWithdrawalLog;
